import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import BankAccount from '../../entities/bankAccount';
import Transaction from '../../entities/transaction';

/*
 * Delete/nullify anywhere this bankAccount is used in other entities
 *
 * @param {BankAccount} bankAccount
 */
export function deleteBankAccount(bankAccount: BankAccount, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = bankAccount.id;
    }
    /* Complex delete usages */
        /* - Delete key/value usages */
    
    findAll<Transaction>('transactions')
        .filter(transactionTemp => transactionTemp.sourceType === 'B' && transactionTemp.source === bankAccount.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Update the target with a null in the field (do NOT delete!)
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    findAll<Transaction>('transactions')
        .filter(transactionTemp => transactionTemp.targetType === 'B' && transactionTemp.target === bankAccount.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Update the target with a null in the field (do NOT delete!)
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    /* Remove the actual bankAccount */
    bankAccount.status = 'D';
    bankAccount.addedOn = newHRTimestamp();
    bankAccount.addedBy = getCurrentUserId();
    bankAccount.importSource = targetImportSource;
    bankAccount.importId = mergeId;
    store.dispatch(Actions.BankAccountActions.removeBankAccountQueue(bankAccount));
    
}

/*
 * Replace anywhere this bankAccount is used in other entities.
 *
 * @param {BankAccount} bankAccount
 * @param {BankAccount} replaceWith
 * @return {BankAccount} - BankAccount will have refs stripped away
 */
export function replaceBankAccount(bankAccount: BankAccount, replaceWith: BankAccount, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = bankAccount.id;
    }
    /* Complex replace usages */
        /* - Modify key/value usages */
    
    findAll<Transaction>('transactions')
        .filter(transactionTemp => transactionTemp.sourceType === 'B' && transactionTemp.source === bankAccount.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Replace the target with the new ID
			_transaction.source = replaceWith.id;
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    findAll<Transaction>('transactions')
        .filter(transactionTemp => transactionTemp.targetType === 'B' && transactionTemp.target === bankAccount.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Replace the target with the new ID
			_transaction.target = replaceWith.id;
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });
    return bankAccount;
}

/*
 * Determine the impact of deleting this bankAccount from other entities
 *
 * @param {BankAccount} bankAccount
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactBankAccount(bankAccount: BankAccount) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Complex delete usages */
        /* - Impact key/value usages */
    
    const transactionSourceTypeImpact = findAll<Transaction>('transactions')
        .filter(transaction => transaction.sourceType === 'B' && transaction.source === bankAccount.id && transaction.status !== 'D');
    transactionSourceTypeImpact.forEach(() => impacts.push('transactions'));

    const transactionTargetTypeImpact = findAll<Transaction>('transactions')
        .filter(transaction => transaction.targetType === 'B' && transaction.target === bankAccount.id && transaction.status !== 'D');
    transactionTargetTypeImpact.forEach(() => impacts.push('transactions*'));

    return util.countDistinct(impacts);
}